import { Spinner } from "react-bootstrap"


export const LoadingLogo = () => {

    return (
        <div className="d-flex justify-content-center flex-wrap m-auto"
            style={{ height: '100vh', maxWidth: '350px', alignContent: 'center' }}>
            <div>
                <div className="fs-4 mb-2">
                    Загрузка...
                </div>
                <div className="text-center">
                    <Spinner />
                </div>
            </div>
        </div>
    )
}